{
    "Profile_SupernovaCommercial_Insureds.additionalInsuredsInfo": "FR: Additional Insureds Info",
    "Profile_SupernovaCommercial_Insureds.details": "FR: Details",
    "Profile_SupernovaCommercial_Insureds.requireAdditionalInsured": "FR: Do any clients or business associates require you to add them as an Additional Insured to your policy?",
    "Profile_SupernovaCommercial_Insureds.additionalInsureds": "FR: Additional Insureds"
}
